var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateGenerated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.734 13H25.5V14.2799H11.734V13ZM11.734 19.3997H18.691V20.6796H11.734V19.3997ZM24.9648 16.1998H11.734V17.4798H23.5891L24.9648 16.1998Z",
    fill: "#CDB04C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8036 12.7596V32.5312H8.44643V8.46875H28.8036V12.7596L29.9317 11.6166C30.1053 11.4431 30.2957 11.2876 30.5 11.1526V7.60938C30.5 7.38145 30.4106 7.16287 30.2516 7.00171C30.0925 6.84054 29.8767 6.75 29.6518 6.75H7.59821C7.37325 6.75 7.15751 6.84054 6.99844 7.00171C6.83937 7.16287 6.75 7.38145 6.75 7.60938V33.3906C6.75 33.6185 6.83937 33.8371 6.99844 33.9983C7.15751 34.1595 7.37325 34.25 7.59821 34.25H29.6518C29.8767 34.25 30.0925 34.1595 30.2516 33.9983C30.4106 33.8371 30.5 33.6185 30.5 33.3906V9.38098C29.98 9.66102 29.3889 8.05556 28.8036 12.7596Z",
    fill: "#CDB04C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateGenerated);
export default __webpack_public_path__ + "static/media/certificate-generated.8fcaddfbfcd0c23b3c566f681265c420.svg";
export { ForwardRef as ReactComponent };